import AxiosInstance from 'config/apiServiceApiGateway'
import { LoadingDockType } from './loadingDock'

export type TimeSlotHeaderType = {
  locationName: string
  locationType: string
  process: string
  loadingDockName: string
}

export type LoadingDockTimeSlotType = {
  id: number
  locationId: number
  loadingDockId: number
  name: string
  startAt: string
  endAt: string
  manpower: number
  manpowerProductivity: number
  timeslotProductivity: number
  isActive: boolean
  createdBy: string
  remarks: string
}

type TimeSlotType = Pick<LoadingDockType, 'id' | 'type' | 'name' | 'location'> & {
  loadingDockTimeSlot: LoadingDockTimeSlotType[]
}

export type TimeSlotParamType = {
  loadingDockId: number | null
}

export type TimeSlotRequestParamType = Partial<TimeSlotParamType>

export interface GetTimeSlotInterface {
  data: TimeSlotType
  message: string
}

export type UpdateTimeSlotDataType = {
  manpower: number
  manpowerProductivity: number
  isActive: boolean
  remarks: string
  executedBy: string
}

export type UpdateTimeSlotStatusDataType = { is_active: boolean; executed_by: string }

export type TimeSlotDataType = {
  id: number
  location_id: number
  loading_dock_id: number
  name: string
  fcfs_slot_name: string
  fcfs_slot_index: number
  manpower: number
  manpower_productivity: number
  timeslot_productivity: number
  slot_range_label: string
  ldts_ids: number[]
  type: 'REGULAR' | 'FCFS_CHILD' | 'FCFS_PARENT'
  is_active: boolean
  remarks: string[]
  start_at: string
  end_at: string
  register_end_at: string
  register_start_at: string
}

export type UpsertFcfsTimeSlotDataType = {
  fcfs_index: number
  ldts_ids: number[]
  register_start_at: string
  register_end_at: string
}

export const fetchTimeSlotListApi = (
  id: number,
  params?: { active?: boolean; page: 'MASTER_TIME_SLOT' | 'JADWAL_PO_SOURCING' },
) =>
  AxiosInstance.Get<{ data: TimeSlotDataType[] }, true>({
    url: '/commercial/internal/:version/loading-docks/:id/time-slots',
    version: 'v1',
    params,
    urlParams: { id },
  })

export const getTimeSlotListApi = (id: number, params?: { active?: boolean }) =>
  AxiosInstance.Get<GetTimeSlotInterface, true>({
    url: '/staff-management/internal/:version/loading-dock/:id/ldts',
    version: 'v1',
    params,
    urlParams: { id },
    convertResponse: true,
  })

export const putTimeSlotApi = (
  loadingDockId: number,
  timeSlotId: number,
  data: UpdateTimeSlotDataType,
) =>
  AxiosInstance.Put({
    url: '/commercial/internal/:version/loading-docks/:loadingDockId/time-slots/:timeSlotId',
    version: 'v1',
    data,
    urlParams: { loadingDockId, timeSlotId },
    convertRequest: true,
  })

export const upsertFcfsTimeSlotApi = (loadingDockId: number, data: UpsertFcfsTimeSlotDataType) =>
  AxiosInstance.Put({
    url: '/commercial/internal/:version/loading-docks/:loadingDockId/time-slots/fcfs',
    version: 'v1',
    data,
    urlParams: { loadingDockId },
  })
